export default "__VITE_ASSET__QCQOzt4X__"